// dependencies
import React, { useEffect, useState } from "react";

import SelectInput, { Result } from "../../../../../components/Inputs/SelectInput";

// store
import useQueryBuilderStore from "../store";

interface BaseProps {
	onChange: (value: any) => void;
	value: unknown;
}

const ReviewCyclePicker = (props: BaseProps) => {
	const [fields, setFields] = useState<Result[]>([]);
	const { onChange, value } = props;

	const [fetchReviewCycles] = useQueryBuilderStore((state) => [state.fetchReviewCycles]);

	const getReviewCycles = async () => {
		const reviewCycles = await fetchReviewCycles();
		setFields(reviewCycles);
	};

	useEffect(() => {
		getReviewCycles();
	}, []);

	// handles the case where value is null (no review cycle selected)
	const formattedValue = value === null ? { value: null, label: "No Review Cycle" } : value;

	return <SelectInput results={fields} onChange={onChange} value={formattedValue as Result} />;
};

export default ReviewCyclePicker;
